import React from "react";
import LoyaltyRewardsHeading from "@widgets/loyaltyRewards/overview/heading/LoyaltyRewardsHeading";
import {Route} from "@/routing/Router";
import LoyaltyRewardsTable from "@widgets/loyaltyRewards/overview/table/LoyaltyRewardsTable";

type Props = {
    route: Route,
};

const LoyaltyRewardsOverview = ({route}: Props) => {
    return (
        <>
            <LoyaltyRewardsHeading route={route}/>

            <div className={"mt-6 md:mt-12"}>
                <LoyaltyRewardsTable/>
            </div>
        </>
    );
};

export default LoyaltyRewardsOverview;